import { jsx as t, jsxs as i } from "react/jsx-runtime";
import "react";
var e = (L) => /* @__PURE__ */ i("svg", {
  width: 20,
  height: 20,
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ...L,
  children: [
    /* @__PURE__ */ t("rect", {
      width: 20,
      height: 20,
      fill: "#F5F5F5"
    }),
    /* @__PURE__ */ t("rect", {
      width: 1876,
      height: 988,
      transform: "translate(-1124 -432)",
      fill: "white"
    }),
    /* @__PURE__ */ t("path", {
      d: "M20 0H0V20H20V0Z",
      fill: "#338AF3"
    }),
    /* @__PURE__ */ t("path", {
      d: "M14.09 10.4165H5.9082C5.9082 10.9814 6.40016 11.4392 6.965 11.4392H6.93094C6.93094 12.0041 7.38879 12.462 7.95367 12.462C7.95367 13.0269 8.41152 13.4847 8.97641 13.4847H11.0218C11.5867 13.4847 12.0446 13.0269 12.0446 12.462C12.6095 12.462 13.0673 12.0041 13.0673 11.4392H13.0332C13.598 11.4392 14.09 10.9813 14.09 10.4165Z",
      fill: "#FFDA44"
    }),
    /* @__PURE__ */ t("path", {
      d: "M12.8323 9.07898C12.8323 10.6431 11.5643 11.9112 10.0002 11.9112C8.43598 11.9112 7.16797 10.6432 7.16797 9.07898",
      fill: "#338AF3"
    }),
    /* @__PURE__ */ t("path", {
      d: "M12.8083 8.81401L11.6611 9.27847L12.272 10.2347L11.0263 10.0296L10.8685 11.1127L10.0008 10.3161L9.13313 11.1127L8.97531 10.0296L7.72965 10.2347L8.34047 9.27843L7.19336 8.81401L8.34051 8.3496L7.72965 7.39339L8.97531 7.59847L9.13316 6.51538L10.0008 7.31194L10.8685 6.51538L11.0263 7.59847L12.272 7.39339L11.6612 8.34964L12.8083 8.81401Z",
      fill: "#FFDA44"
    })
  ]
});
export {
  e as default
};
